import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-barchar',
  templateUrl: './barchar.component.html',
  styleUrls: ['./barchar.component.css']
})
export class BarcharComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    console.log(this.barChartData);
  }

  
  public barChartOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true
  };

   @Input() public mbarChartLabels:string[] = [];
    public barChartType:string = 'bar';
    public barChartLegend:boolean = true;
  
    public barChartColors:Array<any> = [
    {
      backgroundColor: '#29ac3a',
      borderColor: '#29ac3a',
      pointBackgroundColor: '#29ac3a',
      pointBorderColor: '#fafafa',
      pointHoverBackgroundColor: '#fafafa',
      pointHoverBorderColor: 'rgba(105,159,177)'
    },
    { 
      backgroundColor: '#ccce22',
      borderColor: '#ccce22',
      pointBackgroundColor: '#ccce22',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,20,96,1)'
    },
    { 
      backgroundColor: '#d97503',
      borderColor: '#d97503',
      pointBackgroundColor: '#d97503',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,20,96,1)'
    }
  ];
  @Input()  public barChartData:any[] = [];
  
    // events
    public chartClicked(e:any):void {
      console.log(e);
    }
  
    public chartHovered(e:any):void {
      console.log(e);
    }

}

  